import React from "react";
import { withRouter } from "react-router-dom";
import PageApprovalDesktop from "./PageApprovalDesktop";
import PageApprovalMobile from "./PageApprovalMobile";
import ErrorPanel from "../components/ErrorPanel";
import { PERMISSION_DENIED } from "../constants/error_types";
import { getCryptoRandomString } from "../utils/CryptoRandomString";
import Axios from "../../node_modules/axios";
const sampleData = require("./sampleProjectData");

class PageApproval extends React.Component {
  constructor(props) {
    super(props);

    //Set Body styles (only for approval)
    document.body.style.position = "fixed";
    document.body.style.overflow = "hidden";

    const match = props.match;
    const approvalId = match.params.approvalId;
    const secret = match.params.secret;

    this.state = {
      credentials: { approvalId: approvalId, secret: secret },
      valid: null,
      project: null,
      documents: null,
      annotations: [],
      viewport: { width: 0, height: 0 }
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    const { credentials } = this.state;
    getData(
      credentials.approvalId,
      credentials.secret,
      data => {
        this.setState({
          project: data.project,
          documents: data.documents,
          valid: true
        });
      },
      error => {
        this.setState({ valid: false });
      }
    );
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      viewport: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  addAnnotation(data) {
    const id = getCryptoRandomString(8);
    const { annotations } = this.state;

    annotations.push({ id: id, ...data });

    this.setState({ annotations: annotations });

    return id;
  }

  removeAnnotation(id) {
    const { annotations } = this.state;

    for (let i = 0; i < annotations.length; i++) {
      if (annotations[i].id === id) {
        annotations.splice(i, 1);
        break;
      }
    }

    this.setState({ annotations: annotations });
  }

  render() {
    const { viewport, valid, project, documents, annotations } = this.state;
    const isMobile = viewport.width <= 1024;

    if (valid !== null) {
      if (valid === false) {
        return (
          <div style={{ width: "100vw" }}>
            <ErrorPanel type={PERMISSION_DENIED} />
          </div>
        );
      }
    } else {
      return "Loading...";
    }

    if (isMobile) {
      return (
        <PageApprovalMobile
          addAnnotation={data => this.addAnnotation(data)}
          annotations={annotations}
          project={project}
          documents={documents}
        />
      );
    } else {
      return (
        <PageApprovalDesktop
          addAnnotation={data => this.addAnnotation(data)}
          annotations={annotations}
          project={project}
          documents={documents}
        />
      );
    }
  }
}

export default withRouter(PageApproval);

function getData(approvalId, secret, success, error) {
  if (approvalId.length <= 1 || secret.length !== 128) {
    error();
    return;
  }

  Axios.get(
    `https://us-central1-uelstudios-freeway.cloudfunctions.net/approvalData?approval=${approvalId}`,
    { headers: { Authorization: secret } }
  )
    .then(response => {
      const data = response.data;
      success({ project: data.project, documents: data.documents });
    })
    .catch(error);

  /*
  firestore
    .collection(`accounts/${accountId}/approvals`)
    .doc(approvalId)
    .get()
    .then(approval => {
      const projectId = approval.data().project;
      firestore
        .collection(`accounts/${accountId}/projects`)
        .doc(projectId)
        .get()
        .then(project => {
          const projectData = project.data();
          firestore
            .collection(`accounts/${accountId}/projects/${projectId}/documents`)
            .get()
            .then(documents => {
              let documentsArray = [];
              documents.forEach(element => {
                const elementData = element.data();
                documentsArray.push({
                  id: element.id,
                  name: elementData.name,
                  type: elementData.type,
                  src: elementData.url
                });
              });
              success({
                project: { name: projectData.name, status: projectData.status },
                documents: documentsArray
              });
            })
            .catch(error);
        })
        .catch(error);
    })
    .catch(error);
    */
}



// WEBPACK FOOTER //
// ./src/pages/PageApproval.js